const config = {
  //"apiBase": 'http://5dc244d887479d0014436313.mockapi.io/api/v1'
  //"apiBase": 'https://byipbzgyfe.execute-api.us-east-2.amazonaws.com/Dev',
  // "base_url": "http://elaninfra-qa-banker-225017601.us-east-2.elb.amazonaws.com",
  "base_url": `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
  //    "base_url": "http://elan-bankers-dev.tfnhdzy2me.us-east-2.elasticbeanstalk.com"
}

export default config;
